import PropTypes from 'prop-types'

import styles from './TextBlock.module.scss'

const TextBlock = ({ webpart: { text, color, background } }) => (
  <section className={styles.TextBlock} style={{ background }}>
    <div className={styles.Block}>
      <div style={{ color }} className={styles.Description} dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  </section>
)

TextBlock.propTypes = {
  webpart: PropTypes.shape({
    text: PropTypes.string,
    color: PropTypes.string,
    background: PropTypes.string
  })
}

TextBlock.defaultProps = {
  webpart: {
    text: '',
    color: '',
    background: ''
  }
}

export default TextBlock
